module.exports = __webpack_public_path__ + "static/media/archbishop-benjamin.d2ac915f.jpg";